import {AbstractDateParser} from './abstract-date-parser';
import {DateStruct} from './date-struct';
import {isDefined, safeSplit} from "../../libs/utils/epic.utils";

export class GermanDateParser extends AbstractDateParser {

  private readonly DELIMITER: string = '.';

  public override formatLocalDate(date: DateStruct): string {
    return String(date.day).padStart(2, '0')
      + this.DELIMITER + String(date.month).padStart(2, '0')
      + this.DELIMITER + date.year;
  }

  public override formatLocalDayMonth(date: DateStruct): string {
    return String(date.day).padStart(2, '0')
      + this.DELIMITER + String(date.month).padStart(2, '0');
  }

  public override parseLocalDate(value: Date | string | null | undefined): DateStruct {
    if (isDefined(value)) {
      if (value instanceof Date) {
        return DateStruct.fromDate(value);
      }
      const date: string[] = safeSplit(value, this.DELIMITER);
      return new DateStruct({
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      });
    }
    return new DateStruct();
  }
}
